/* eslint-disable no-return-assign */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import * as actions from '../actions';

function ViewUpdateBusinessActivityItem({
  id,
  data,
  activityFormData,
  setActivityFormData,
}) {
  const [formUpdate, setFormUpdate] = useState({
    ...data.attributes.yearly_gross_amount,
  });

  useEffect(() => {
    setActivityFormData({
      ...activityFormData,
      activities: [
        ...(activityFormData.activities.map((item, yearId) => {
          return yearId === id
            ? { ...item, yearly_gross_amount: { ...formUpdate } }
            : item;
        }) || ''),
      ],
    });
  }, [formUpdate]);

  const formRules = {};

  Object.keys(data.attributes.yearly_gross_amount).forEach(key => {
    formRules[key] = 'required|number';
  });

  const validateUpdateForm = useFormValidator(formUpdate, {
    ...formRules,
  });

  return (
    <div className="row">
      <div className="col-12">
        <label className="form-label">Yearly Gross Amount</label>
        <div className="row">
          {Object.keys(data.attributes.yearly_gross_amount).map(year => {
            return (
              <div className="col-6">
                <div key={`yearly_gross_amount${year}`} className="mb-3">
                  <label className="form-label">
                    {`${year}`} {validateUpdateForm.renderMessage(year)}
                  </label>
                  <NumberFormat
                    name={year}
                    id={year}
                    placeholder="0"
                    className="form-control"
                    onValueChange={values => {
                      const { value } = values;
                      setFormUpdate({
                        ...formUpdate,
                        [year]: value,
                      });
                    }}
                    /* eslint-disable */
                    isNumericString={true}
                    thousandSeparator={true}
                    allowNegative={true}
                    allowLeadingZeros={true}
                    displayType="input"
                    prefix=""
                    value={`${_.get(formUpdate, year, '')}` || ''}
                  />
                </div>
              </div>
            );
          }) || ''}
        </div>
      </div>
    </div>
  );
}

ViewUpdateBusinessActivityItem.propTypes = {
  id: PropTypes.number.isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  activityFormData: PropTypes.instanceOf(Object).isRequired,
  setActivityFormData: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewUpdateBusinessActivityItem);
